import { ToolsetSettingsType } from '../../../../../gamma-api';
import { IbIconName } from '../../../../components/common/IbIcon';
import { getTranslateFunc } from '../../../../utils/stringUtil';

export const translate = getTranslateFunc('Agent: Toolset:');

export const getToolsetTypeIconName = (type: ToolsetSettingsType): IbIconName => {
  if (type === ToolsetSettingsType.McpServer) {
    return 'server';
  }

  if (type === ToolsetSettingsType.DateTime) {
    return 'time';
  }

  if (type === ToolsetSettingsType.SmartSearch) {
    return 'optimize';
  }

  if (type === ToolsetSettingsType.Web) {
    return 'link-two';
  }

  if (type === ToolsetSettingsType.Elma365General) {
    return 'elma365';
  }

  if (type === ToolsetSettingsType.Elma365Toolkit) {
    return 'elma365';
  }

  if (type === ToolsetSettingsType.File) {
    return 'file-text';
  }

  if (type === ToolsetSettingsType.Agent) {
    return 'user-business';
  }

  return 'server';
};

export const getToolsetTypeName = (type: ToolsetSettingsType): string => {
  if (type === ToolsetSettingsType.McpServer) {
    return translate('Modal: MCP Server: Title');
  }

  if (type === ToolsetSettingsType.DateTime) {
    return translate('Modal: DateTime: Title');
  }

  if (type === ToolsetSettingsType.SmartSearch) {
    return translate('Modal: Smart search: Title');
  }

  if (type === ToolsetSettingsType.Web) {
    return translate('Modal: Web: Title');
  }

  if (type === ToolsetSettingsType.Elma365General) {
    return translate('Modal: ELMA365: General: Title');
  }

  if (type === ToolsetSettingsType.Elma365Toolkit) {
    return translate('Modal: ELMA365: Toolkit: Title');
  }

  if (type === ToolsetSettingsType.File) {
    return translate('Modal: File: Title');
  }

  if (type === ToolsetSettingsType.Agent) {
    return translate('Modal: Agent: Title');
  }

  throw new Error(`Agent toolset type '${type}' is not supported`);
};
